import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { CreationHubPage } from './CreationHubPage';

const CreationHubPageBridge = react2angular(CreationHubPage, []);
export default CreationHubPageBridge;
